import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "notification-bell dropdown" }
const _hoisted_2 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "bell-box-dropdown"
}
const _hoisted_3 = { class: "list-group" }
const _hoisted_4 = { class: "list-group-item list-group-item-action" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { class: "small text-right" }
const _hoisted_13 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("button", {
      id: "bell-box-dropdown",
      class: "btn border-0",
      "data-toggle": "dropdown"
    }, [
      _createElementVNode("i", { class: "fas fa-bell" }),
      _createElementVNode("i", { class: "fas fa-circle text-danger d-none" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (e) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (e.type === 'ProjectCreate')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("b", null, _toDisplayString(e.author.name), 1),
                    _cache[0] || (_cache[0] = _createTextVNode(" has created new project ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.projectName), 1)
                  ]))
                : _createCommentVNode("", true),
              (e.type === 'ProjectRename')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("b", null, _toDisplayString(e.author.name), 1),
                    _cache[1] || (_cache[1] = _createTextVNode(" has renamed project ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.projectName), 1),
                    _cache[2] || (_cache[2] = _createTextVNode(" to ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.newProjectName), 1)
                  ]))
                : _createCommentVNode("", true),
              (e.type === 'NewInvite')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createTextVNode(" You was invited by ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.author.name), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(" to ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.teamName), 1),
                    _cache[5] || (_cache[5] = _createTextVNode(" team ", -1))
                  ]))
                : _createCommentVNode("", true),
              (e.type === 'ProjectRemove')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("b", null, _toDisplayString(e.author.name), 1),
                    _cache[6] || (_cache[6] = _createTextVNode(" has removed ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.projectName), 1)
                  ]))
                : _createCommentVNode("", true),
              (e.type === 'ProjectRevert')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("b", null, _toDisplayString(e.author.name), 1),
                    _cache[7] || (_cache[7] = _createTextVNode(" has reverted project ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.projectName), 1)
                  ]))
                : _createCommentVNode("", true),
              (e.type === 'ProjectLockStatusChange' && e.locked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("b", null, _toDisplayString(e.author.name), 1),
                    _cache[8] || (_cache[8] = _createTextVNode(" has acquired lock on project ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.projectName), 1)
                  ]))
                : _createCommentVNode("", true),
              (e.type === 'ProjectLockStatusChange' && !e.locked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("b", null, _toDisplayString(e.author.name), 1),
                    _cache[9] || (_cache[9] = _createTextVNode(" has released lock on project ", -1)),
                    _createElementVNode("b", null, _toDisplayString(e.projectName), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.timestampString(e.timestamp)), 1)
            ]))
          }), 256))
        ])
      ], 512), [
        [_vShow, _ctx.hasEvents()]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_13, " No new notifications. ", 512), [
        [_vShow, !_ctx.hasEvents()]
      ])
    ])
  ]))
}